import React from "react"
import "./index.css"

const EventCatering = () => {
  return (
    <section id="event-location-bottom-img">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h3 className="text-center">EXQUISITES CATERING FÜR IHR EVENT</h3>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 paragraph">
            <p>
              Lassen Sie sich auch kulinarisch verführen, vom ausgefallenen
              Snack bis zum erlesenen 3-Gang-Menü, und genießen Sie die Show bei
              einer guten Flasche Wein, einem prickelnden Glas Champagner oder
              einem raffinierten Cocktail.
            </p>
          </div>
          <div className="col-md-7"></div>
        </div>

        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4  event-unorder">
            <ul className="list">
              <li>
                <i className="fa fa-caret-right pr-2"></i>SHOW & DINE
              </li>
              <li>
                <i className="fa fa-caret-right pr-2"></i>SHOW & WINE
              </li>
              <li>
                <i className="fa fa-caret-right pr-2"></i>RESTAURANT
              </li>
              <li>
                <i className="fa fa-caret-right pr-2"></i>LE BISTRO
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="text-center">
              <button type="button" className="btn die-show-btn">
                GENIESSEN
              </button>
              <button type="button" className="btn tickets-btn">
                RESERVIEREN
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EventCatering
